// extracted by mini-css-extract-plugin
export default {"CardSelector":"CardSelector_CardSelector__YZhjP","CardSelector--active":"CardSelector_CardSelector--active__nfhKv","CardSelector__input":"CardSelector_CardSelector__input__iUJFA"};